import React from 'react'
import Shivam from './images/Coordinators/shivam.png'
import aftab from './images/Coordinators/aftab.png'
import kritarth from './images/Coordinators/kritarth1.png'
import Wilson from './images/Coordinators/Wilson.png'

const TechHeads = () => {
    return (
        <div className="container"
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
                margin: '30px',
            }}>

            <div className="mainBg"
                style={{
                    // background: 'conic-gradient(from 90deg at 1px 1px,#0000 90deg,white 0) 0 0/50px 50px',
                    // backgroundColor: 'pink',
                    minWidth: '300px',
                    minHeight: '400px',
                    borderRadius: '25px',
                    padding: '10px 30px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    flexWrap: 'wrap',

                }}
            >
                <h1 style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    minWidth: '300px',
                    height: '200px',
                    marginTop: '5px'
                }}>
                    <span style={{ fontSize: '2.8rem', letterSpacing: '5px' }}>
                        TECHNICAL HEADS
                    </span>
                    {/* <span style={{ fontSize: '4.4rem', lineHeight: '40px', letterSpacing: '10px' }}>
                        HEADS
                    </span> */}
                </h1>
                <div style={{
                    // width:'500px',
                    // border:'1px solid red',
                    minWidth: '300px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }}>

                    <div className="techHeads" style={{
                        position: 'relative',
                        width: '200px',
                        height: '200px',
                        margin: '40px 10px',
                    }}>
                        <div style={{
                            width: '190px',
                            height: '190px',
                            maxWidth: '230px',
                            clipPath: 'circle(50% at 50% 50%)',
                            background: '#ccc',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            position: 'absolute',
                            bottom: '0px',
                        }}>
                        </div>
                        <a href='https://www.linkedin.com/in/aftab-ahmed-225808195/' target="_blank" rel="noreferrer">
                            <img src={aftab} alt="aftab"
                                style={{
                                    position: 'absolute',
                                    top: '-35px',
                                    height: '200px',
                                    left: '25px',
                                    filter: 'brightness(90%) contrast(175%)',
                                }} />
                        </a>
                        <div className="techHead"
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                width: '190px',
                                height: '30px',
                                textAlign: 'center',
                            }}>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                            }}>
                                Aftab Ahmed
                            </div>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                                borderTop: '0px',
                            }}>
                                Full Stack Developer
                            </div>
                        </div>
                    </div>

                    <div className="techHeads" style={{
                        position: 'relative',
                        width: '200px',
                        margin: '40px 10px',
                        height: '200px',
                        gridColumnStart: '3',
                        gridColumnEnd: '4',
                    }}>
                        <div style={{
                            width: '190px',
                            height: '160px',
                            maxWidth: '230px',
                            clipPath: 'circle(50% at 50% 50%)',
                            background: '#974645cc',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            position: 'absolute',
                            bottom: '30px',
                        }}>
                        </div>
                        <a href='https://www.linkedin.com/in/shivam-s-652877ba/' target="_blank" rel="noreferrer">
                            <img src={Shivam} alt="Shivam"
                                style={{
                                    position: 'absolute',
                                    top: '-35px',
                                    borderRadius: '25% 25% 49% 51% / 0% 0% 21% 21%',
                                    filter: 'brightness(120%)',
                                }} />
                        </a>
                        <div className="techHead"
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                width: '190px',
                                height: '30px',
                                textAlign: 'center',
                            }}>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                            }}>
                                Shivam Sharma
                            </div>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                                borderTop: '0px',
                            }}>
                                Full Stack Developer
                            </div>
                        </div>
                    </div>

                    <div className="techHeads" style={{
                        position: 'relative',
                        width: '200px',
                        height: '200px',
                        margin: '40px 10px',
                    }}>
                        <div style={{
                            width: '160px',
                            height: '160px',
                            maxWidth: '230px',
                            clipPath: 'circle(50% at 50% 50%)',
                            // clipPath: 'polygon(50% 0%, 100% 38%, 100% 100%, 0 100%, 0% 38%)',
                            background: '#faa24b',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            position: 'absolute',
                            bottom: '30px',
                        }}>
                        </div>
                        <a href="https://www.linkedin.com/in/kritarth-tripathi-a45b8b219/" target="_blank" rel="noreferrer">
                            <img src={kritarth} alt="kritarth"
                                style={{
                                    position: 'absolute',
                                    top: '-70px',
                                    left: '25px',
                                    height: '250px',
                                    borderRadius: '25% 25% 49% 51% / 0% 0% 21% 21%',
                                    // clipPath: 'polygon(50% 0%, 100% 0, 100% 64%, 100% 85%, 80% 91%, 49% 98%, 21% 91%, 0 84%, 0 64%, 0 0)',
                                    filter: 'brightness(120%)',
                                }} />
                        </a>
                        <div className="techHead"
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                width: '190px',
                                height: '30px',
                                textAlign: 'center',
                            }}>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                            }}>
                                Kritarth Tripathi
                            </div>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                                borderTop: '0px',
                            }}>
                                Android Developer
                            </div>
                        </div>
                    </div>

                    <div className="techHeads" style={{
                        position: 'relative',
                        width: '200px',
                        height: '200px',
                        margin: '40px 10px',
                    }}>
                        <div style={{
                            width: '160px',
                            height: '160px',
                            maxWidth: '230px',
                            // clipPath: 'polygon(50% 0%, 100% 38%, 100% 100%, 0 100%, 0% 38%)',
                            clipPath: 'circle(50% at 50% 50%)',
                            background: '#0c64fd',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            position: 'absolute',
                            bottom: '30px',
                        }}>
                        </div>
                        <a href="https://www.linkedin.com/in/wilson-daniel-06290b1b1/" target="_blank" rel="noreferrer">
                            <img src={Wilson} alt="wilson"
                                style={{
                                    position: 'absolute',
                                    top: '-40px',
                                    left: '-10px',
                                    height: '210px',
                                    borderRadius: '25% 25% 49% 51% / 0% 0% 21% 21%',
                                    // clipPath: 'polygon(50% 0%, 100% 0, 100% 64%, 100% 85%, 80% 91%, 49% 98%, 21% 91%, 0 84%, 0 64%, 0 0)',
                                    filter: 'brightness(180%)',
                                }} />
                        </a>
                        <div className="techHead"
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                width: '190px',
                                height: '30px',
                                textAlign: 'center',
                            }}>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                            }}>
                                Wilson Daniel
                            </div>
                            <div style={{
                                background: 'pink',
                                width: '100%',
                                padding: '0px 5px',
                                fontWeight: 'bold',
                                border: '2px solid white',
                                borderTop: '0px',
                            }}>
                                Graphic Designer
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TechHeads